import { useEffect } from "react";

const SITE_URL = process.env.REACT_APP_SITE_URL;
export const DEFAULT_TITLE = "Acompanhamento Metabólico em Tucuruí-PA | Centro de Performance Farmacêutica";
export const DEFAULT_DESC = "Farmacêutico clínico em Tucuruí-PA com acompanhamento metabólico no Pará: reposição de vitaminas, vitamina D e B12, colesterol alto com tratamento natural, fígado inflamado e esteatose hepática.";
export const DEFAULT_KEYWORDS = "farmacêutico clínico Tucuruí-PA, acompanhamento metabólico Pará, reposição de vitaminas Tucuruí, reposição vitamina D e B12, colesterol alto tratamento natural, fígado inflamado, esteatose hepática tratamento";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const apply = (title, description, keywords, path) => {
  const url = `${SITE_URL}${path}`;
  document.title = title;
  setMeta("name", "description", description);
  setMeta("name", "keywords", keywords);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", url);
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  setCanonical(url);
};

export default function useSeo({ title, description, keywords, path }) {
  useEffect(() => {
    if (!title) return undefined;
    apply(title, description || DEFAULT_DESC, keywords || DEFAULT_KEYWORDS, path);
    return () => apply(DEFAULT_TITLE, DEFAULT_DESC, DEFAULT_KEYWORDS, "/");
  }, [title, description, keywords, path]);
}
